import LoadingSpinner from "./loading.gif";

export const Loading = () => {
    return (
        <img src={LoadingSpinner} alt="Loading" />
    )
}